const ALERT_MESSAGE = {
    DISCOUNT_ITEM_NEGATIVE: "Discount will cause the item to be negative",
    INVOICE_NEGATIVE: "Invoice total cannot be negative",
    ESTIMATE_NEGATIVE: "Estimate total cannot be negative",
    DISCOUNT_CANNT_BE_APPLIED: "Discount cannot be applied to this item.",
    LOW_VALUE_LOWER_THAN_HIGH:
        "Low quantity should not be greater than high quantity.",
    REMOVE_DISCOUNT_MESSAGE:
        "Discount not applied because it would cause the item to be negative.",
    LOW_UNIT_PRICE_VALUE_LOWER_THAN_HIGH:
        "Low unit price should not be greater than high unit price.",
};

const BUNDLE_TYPE = {
    INVOICE: 1,
    ESTIMATE: 11
};

const ERROR_MESSAGE = {
    INVOICE_DELETED: "INVOICE_DELETED",
    INVOICE_WRITTEN_OFF: "INVOICE_WRITTEN_OFF"
};

const DISCOUNTS = {
    CUSTOM: {
        id: "D0000000000000-1",
        name: "Custom Discount"
    },
    INVOICE: {
        id: "D0000000000000-2",
        name: "Invoice level discount applied"
    },
    WELLNESS: {
        id: "D0000000000000-3",
        name: "Wellness plan discount applied"
    }
};

const INVOICE_LIST_STATUS = {
    WRITE_OFF: 3,
    OPEN: 7,
    UNPAID: 1,
    PAID: 2,
    LOCKED: 5,
    REOPENED: 6
};

export default {
    ALERT_MESSAGE,
    ERROR_MESSAGE,
    DISCOUNTS,
    BUNDLE_TYPE,
    INVOICE_LIST_STATUS
};
